import { render, staticRenderFns } from "./app-doc.vue?vue&type=template&id=1af03f63"
import script from "./app-doc.vue?vue&type=script&lang=js"
export * from "./app-doc.vue?vue&type=script&lang=js"
import style0 from "./app-doc.vue?vue&type=style&index=0&id=1af03f63&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports